(function ($) {
  'use strict';

  const feedbackRequestComment = success => {
    const $iconRequestComment = $('.js-icon-request-comment');
    const $titleRequestComment = $('.js-title-request-comment');
    const $textRequestComment = $('.js-text-request-comment');
    const $btnRequestComment = $('.js-button-request-comment');

    if (success) {
      $iconRequestComment
        .addClass('success')
        .find('i')
        .removeClass('q-icon-inbox')
        .addClass('q-icon-check-circle');
      $titleRequestComment.html('Pedido realizado!');
      $textRequestComment.html(
        'Quando um concurseiro comentar nesta questão, você será notificado por e-mail.'
      );
      $btnRequestComment.html('Pedido realizado').attr('disabled', true);

      // tracking
      UserTracker.emit('event', {
        eventName: 'student commentary requested'
      });
    } else {
      $iconRequestComment
        .removeClass('success')
        .find('i')
        .removeClass('q-icon-check-circle')
        .addClass('q-icon-inbox');
      $titleRequestComment.html('Precisa de ajuda?');
      $textRequestComment.html(
        'Vamos buscar outros concurseiros para te auxiliar e comentar nesta questão. Você receberá um aviso por e-mail quando um novo comentário for feito.'
      );
      $btnRequestComment.html('Pedir Comentário').attr('disabled', false);
    }
  };

  const emitToastr = ({ type, text, link = false }) => {
    const message = link ? text + link : text;

    return toastr[type](message);
  };

  const removeFavorite = (segment_id, resource_id, product, $button) => {
    Thor.Favorite.delete(
      {},
      {
        qs: { segment_id, resource_id },
        data: { product }
      }
    ).then(() => {
      const { toFollowText } = $button.data();

      $button.find('.js-favorite-text').html(toFollowText);

      $button.removeClass('is-following').attr('disabled', false).blur();

      feedbackRequestComment(false);

      emitToastr({
        type: 'info',
        text: 'Atualização dos comentários da questão desativada'
      });
    });
  };

  const addFavorite = (segment_id, resource_id, product, $button) => {
    Thor.Favorite.create(
      {},
      {
        data: { favorite: { segment_id, resource_id }, product }
      }
    ).then(() => {
      const { followingText } = $button.data();

      $button.find('.js-favorite-text').html(followingText);

      $button.addClass('is-following').attr('disabled', false).blur();

      feedbackRequestComment(true);

      emitToastr({
        type: 'success',
        text: 'Acompanhando comentários da questão',
        link:
          gon.favorites_url &&
          `<div><a href="${gon.favorites_url}"><strong>Acessar</strong></a></div>`
      });
    });
  };

  // Prevent to double bind our favorite button :D
  $(document)
    .off('click.favorite', '.js-favorite')
    .on('click.favorite', '.js-favorite', event => {
      event.preventDefault();
      event.stopPropagation();
      const $button = $(event.currentTarget);
      const { segment, resource, product } = $button.data();
      const isFavorite = $button.hasClass('is-following');

      $button.attr('disabled', true);

      if (isFavorite) {
        removeFavorite(segment, resource, product, $button);
      } else {
        addFavorite(segment, resource, product, $button);
      }
    });
})(jQuery);
